import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed, onMounted } from 'vue';

type Props = {
    error: any;
    status?: string|number;
    message?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FullscreenErrorMessage',
  props: {
    error: null,
    status: { default: 500 },
    message: null
  },
  setup(__props: any) {

const props = __props as { error: any, status: string|number, message?: string };



const status = computed<string>(() => {
    if (props.error && props.error.status) {
        return props.error.status;
    }

    return props.status;
});

let clonedErrorMessage = '';
const message = computed<string>(() => (props.error && props.error.clone ? clonedErrorMessage : props.message ?? ''));

onMounted(async () => {
    if (props.error && props.error.clone) {
        clonedErrorMessage = await props.error.clone().text();
    }
});

return { __sfc: true,props, status, clonedErrorMessage, message }
}

})